import type React from "react";
import { Link } from "react-router-dom";

type Props = {
  title: string;
  toLink: string;
  classBtn: string;
  styles: React.CSSProperties[];
}

export const NewBuy = ({ title, toLink, classBtn, styles = [] }: Props):JSX.Element => {
  const stylesObject = Object.assign({}, ...styles);
  return (
    <Link to={toLink} className={classBtn} style={stylesObject}>
      {title}
    </Link>
  );
};
